import { OccupationModel } from '@/apiTypes/OccupationTypes.ts';
import { avatarUrls } from './avatarUrls.generated';

const avatarAltText: Record<string, string> = {
    avatar1: 'Illustrated avatar of a person with short dark hair and light skin wearing a red top, on a lime green circular background',
    avatar2: 'Illustrated avatar of a person with red hair wearing headphones, eyes closed, on a blue circular background',
    avatar3: 'Illustrated avatar of a person with long black hair and pink skin wearing a yellow top, on a blue circular background',
    avatar4: 'Illustrated avatar of a person with short black hair wearing a blue collared shirt and pink tie, on a purple circular background',
    avatar5: 'Illustrated avatar of a person with curly black hair and blue skin wearing a pink jacket, on a peach circular background',
    avatar6: 'Illustrated avatar of a person with long black hair in a ponytail wearing dark sunglasses, with pink skin, on a light blue circular background',
    avatar7: 'Illustrated avatar of a person with curly black hair and glasses, with purple skin wearing a pink top, on a yellow circular background',
    avatar8: 'Illustrated avatar of a person with black hair and pink skin looking upward, wearing a green top, on a yellow circular background',
    avatar9: 'Illustrated avatar of a person with short black hair and glasses, with bright pink skin wearing a dark purple top, on a light blue circular background',
    avatar10: 'Illustrated avatar of a person with black hair in a bun and glasses, with blue skin wearing a pink top, on an orange circular background',
};

export const getAvatars = (avatarGlob: Record<string, unknown> = avatarUrls) => {
    return Object.entries(avatarGlob).map(([key, value]) => {
        const id = key.split('/').pop()?.split('.').shift() || key;
        return {
            id,
            fallback: 'AV',
            src: value as string,
            alt: avatarAltText[id] || id,
        };
    });
};

export const getAvatarByOccupation = (occupation: OccupationModel | undefined) => {
    if (occupation?.avatarImageName) {
        return `/api/public/occupation-avatars-v2/${occupation.avatarImageName}`;
    }

    return `/api/public/occupation-avatars-v2/categories/${occupation?.category?.avatarImageName || 'general.png'}`;
};

export const getCategoryAvatar = (avatarImageName: string | undefined) => {
    return `/api/public/occupation-avatars-v2/categories/${avatarImageName || 'general.png'}`;
};
